import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { useI18n } from '@hydra/common/components/i18n';

import formatNumber from '@hydra/utils/formatNumber';
import ProgressBar from '@hydra/common/components/ProgressBar';
import Criterium from '@hydra/common/criterium/Criterium';
import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';
import { useReviewContext } from '@hydra/common/context/review';
import { usePdfTemplateContext } from '@hydra/common/context/pdfTemplate';

const useStyles = makeStyles(theme => ({
  number: {
    marginBottom: theme.spacing(1)
  }
}));

export const calculatePercent = indexedPages => {
  // use a logarithmic scale for calculating the bar
  // ---------------
  //      0 => 0
  //     10 => 0.25
  //    100 => 0.5
  //  1 000 => 0.75
  // 10 000 => 1
  const percent = Math.log10(indexedPages + 1) * 0.25;
  return Math.round(Math.min(percent, 1) * 100);
};

export const IndexedPages = ({ criterium }) => {
  const classes = useStyles();
  const { numeral } = useI18n();

  const { isPdf } = useReviewContext();
  const { templateColors } = usePdfTemplateContext();
  const { primary } = isPdf
    ? templateColors
    : getPriSecColors();
  const color = getContrastedColor(primary);

  const { data, url } = criterium;

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, indexedPagesCount: numeral(data || 0).format() }}
    >
      <div className={classes.number}>{formatNumber(data)}</div>
      <ProgressBar
        value={calculatePercent(data)}
        color={color}
      />
    </Criterium>
  );
};

IndexedPages.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.number
  })
};

export default React.memo(IndexedPages);
